export class Mode{
    public static taskMode:string='T';
    public static assignMode:string='A';
    public static reviewMode:string='R';


}